<template>
    <div class="datatable-simple">

        <a v-if="dataSet" :href="data.page" v-for="(data, index) in dataSet" class="row">
            <div class="col-md-4">
                <span class="text-muted"><b> {{ data.data.name }}, </b>{{ formatDate(data.created_at) }}</span>
            </div>
            <div class="col-md-8" v-html="data.data.message"></div>
        </a>
        <div v-if="!dataSet.length" class="text-center">
             {{ $t('nothing_to_show_here') }}
        </div>

    </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
export default {
    name: "History",
    props: {
        dataSet: {
            type: Array
        },
    },
    methods: {
        formatDate(date) {
            let formattedDate = moment(date).format('DD. MM. HH:mm');
            return formattedDate;
        }

    },

}
</script>
